import { defineMessages } from "react-intl";

import {
	anaemiaTypeMessages,
	hasDiseaseMessages,
	renalAnaemiaHematologyTypeMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/renalAnaemiaHematology";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	renalAnaemiaHematology: {
		id: "ktx.form.renal_anaemia_hematology.title",
		defaultMessage: "Renális anaemia - hematológia"
	},
	type: {
		id: "ktx.form.renal_anaemia_hematology.type",
		defaultMessage: "Típusa"
	},
	anaemiaType: {
		id: "ktx.form.renal_anaemia_hematology.anaemia_type",
		defaultMessage: "Aneamia típusa"
	},
	hasDisease: {
		id: "ktx.form.renal_anaemia_hematology.hasDisease",
		defaultMessage: "Aneamia?"
	},
	comment: {
		id: "ktx.form.renal_anaemia_hematology.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["hasDisease"],
						label: messages.hasDisease,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: { labels: hasDiseaseMessages }
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["diseases", "renalAnaemiaHematologyType"],
						label: messages.type,
						errorMessages: genericErrorMessages,
						input: {
							type: "checkbox-group",
							props: {
								labels: renalAnaemiaHematologyTypeMessages,
								direction: "vertical",
								columns: 2
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["diseases", "anaemiaType"],
						label: messages.anaemiaType,
						errorMessages: genericErrorMessages,
						input: {
							type: "select",
							props: { labels: anaemiaTypeMessages }
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["comment"],
						label: messages.comment,
						errorMessages: genericErrorMessages,
						input: { type: "textarea", props: {} }
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_renalAnaemiaHematology",
	value: {
		schemaId: "renalAnaemiaHematology",
		title: messages.renalAnaemiaHematology,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
